import { ChartSeries } from './index';
import type {
    ILineChartSeries,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/line-chart.interface';
import type { SerRules } from './index';
import type { DeltaOf, ILineChartSerData } from '@tencent/slide-sdk-model';
import _has from 'lodash/has';
import { setUIValueToSdkData } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/properties/util';

export class LineChartSeries extends ChartSeries implements ILineChartSeries {
    public static convertDataUiToSdk(uiData) {
        const sdkData = super.convertDataUiToSdk(uiData) as DeltaOf<ILineChartSerData>;

        if (_has(uiData, 'smooth')) {
            setUIValueToSdkData(sdkData, 'smooth', uiData.smooth);
        }

        return sdkData;
    }

    // 是否是平滑线
    public smooth: boolean;
    public constructor(serData: ILineChartSerData, options: SerRules) {
        super(serData, options);
        const { smooth } = serData;
        this.smooth = !!smooth?.val;
    }
}
